console.log('From article promoted component!!!');